import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ClassesComponent } from './classes.component';
import { ClassesHomeComponent } from './components/home/classes-home.component';
import { ClassesAttachedComponent } from './components/attached/classes-attached.component';
import { ClassesRankingComponent } from './components/ranking/list/classes-ranking.component';
import { ClassesRankingClassifComponent } from './components/ranking/classification/classes-ranking-classif.component';

const routes: Routes = [
    {
        path: '',
        component: ClassesComponent,
        children: [
            { path: 'home', component: ClassesHomeComponent },
            {
                path: 'tournament',
                loadChildren: () => import('../tournament/tournament.module').then((m) => m.TournamentModule),
            },
            { path: 'ranking-2', loadChildren: () => import('../ranking/ranking.module').then((m) => m.RankingModule) },
            { path: 'ranking', component: ClassesRankingComponent },
            {
                path: 'ranking-classif/:rankingId',
                component: ClassesRankingClassifComponent,
            },
            {
                path: 'attached/:sessionType',
                component: ClassesAttachedComponent,
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class ClassesRoutingModule {}
